const { jsPDF } = require('jspdf');
const { autoTable } = require('jspdf-autotable');
const { drawMunicipalPdfHeader } = require('./municipalPdfHeader');
function buildExternalRepairPdf(records) {
    if (!records.length) throw new Error('Remessa sem equipamentos.');
    const doc = new jsPDF({ unit: 'mm', format: 'a4', compress: true });
    const first = records[0];
    const header = () => {
        let y = drawMunicipalPdfHeader(doc, first.receiptSecretary || first.equipment?.local?.unit?.secretary?.name);
        doc.setFont('helvetica', 'bold'); doc.setFontSize(15);
        doc.text('Envio para manutenção externa', 18, y); y += 7;
        doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
        for (const text of [
            `Remessa: ${first.shipmentId || first.id}`,
            `Empresa: ${first.receiptCompany || first.company?.fantasyName || ''} - CNPJ: ${first.receiptCnpj || first.company?.cnpj || 'Não informado'}`,
            `Data de emissão: ${(first.shippingDate || '').slice(0, 10).split('-').reverse().join('/')} às ${(first.shippingDate || '').slice(11, 19)}`,
        ]) { const lines = doc.splitTextToSize(text, 174); doc.text(lines, 18, y); y += lines.length * 4.5 + 2; }
        return y + 3;
    };
    const startY = header();
    autoTable(doc, {
        startY, margin: { top: startY, bottom: 18, left: 18, right: 18 }, theme: 'grid',
        head: [['Equipamento / identificação', 'Unidade / Local', 'Problema apresentado', 'Data de retorno']],
        body: records.map(r => [
            `${r.receiptModel || r.equipment?.model?.name || ''}\nPatrimônio: ${r.receiptPatrimony || r.equipment?.patrimony || 'Não informado'}\nSérie: ${r.receiptSerial || r.equipment?.serialNumber || 'Não informada'}`,
            r.receiptLocation || `${r.equipment?.local?.unit?.name || ''} / ${r.equipment?.local?.name || ''}`,
            r.problemReported, '\n____/____/______\n',
        ]),
        styles: { font: 'helvetica', fontSize: 8, cellPadding: 3, overflow: 'linebreak', lineColor: [210, 215, 220], lineWidth: 0.15 },
        headStyles: { fillColor: [35, 57, 79], textColor: 255 },
        columnStyles: { 0: { cellWidth: 51 }, 1: { cellWidth: 36 }, 2: { cellWidth: 56 }, 3: { cellWidth: 31 } },
        rowPageBreak: 'avoid', didDrawPage: header,
    });
    let y = doc.lastAutoTable.finalY + 12;
    if (y + 53 > 278) { doc.addPage(); y = header(); }
    doc.setFontSize(10); doc.setFont('helvetica', 'normal'); doc.setTextColor(27, 45, 66);
    const statement = doc.splitTextToSize('Declaro que recebi os equipamentos relacionados neste documento para manutenção. O retorno de cada equipamento será registrado individualmente.', 174);
    doc.text(statement, 18, y); y += statement.length * 5 + 16;
    doc.setDrawColor(90, 102, 115); doc.line(18, y, 125, y); doc.line(139, y, 192, y);
    doc.setFontSize(9); doc.text('Assinatura da empresa', 18, y + 5); doc.text('Data da retirada', 139, y + 5);
    for (let p = 1; p <= doc.getNumberOfPages(); p++) {
        doc.setPage(p); doc.setFontSize(8); doc.setTextColor(100, 110, 120);
        doc.text('Comprovante de envio para manutenção externa', 18, 287);
        doc.text(`Página ${p} de ${doc.getNumberOfPages()}`, 192, 287, { align: 'right' });
    }
    return doc;
}
function downloadExternalRepairPdf(records) {
    buildExternalRepairPdf(records).save(`manutencao-externa-${records[0].shipmentId || records[0].id}.pdf`);
}
module.exports = { buildExternalRepairPdf, downloadExternalRepairPdf };
